export const optOutInstructions = (
  staticBodyChunk = "msgs/month. Reply STOP to cancel, HELP for help. Msg/data rates apply. Terms & Privacy https://skip.io/#/tos/",
  messagesPerMonth = 0,
  slug
) => `${messagesPerMonth} ${staticBodyChunk}${slug || "lmnop"}`;
